import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getAdditives = async (page: number, filters: any) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/additives`, { params: {page, size: 10, ...filters },
            withCredentials: true
        });

        const transformedAdditives = response.data.data.additives.content.map((item: any) => ({
            NOMBRE: item.name,
            CLAVE: item.uniqueCode,
            ID: item.id
        }));

        return {
            additives: transformedAdditives || [],
            page: response.data.data.additives.number,
            totalPages: response.data.data.additives.totalPages,
        }

    } catch (error) {
        throw error;
    }
}

export const addAdditive = async (newAdditive: any) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/additives`, newAdditive , {withCredentials: true});
        return response.data;

    } catch (error) {
        throw error;
    }
}

export const getAdditivesByUniqueCode = async (id: number) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/additives/${id}`, {withCredentials: true});
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateAdditive = async (updatedAdditiveDTO: any, id: number) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/additives/${id}`, updatedAdditiveDTO , {withCredentials: true});
        return response.data;

    } catch (error) {
        throw error;
    }
}
